import { action, computed, observable, runInAction } from 'mobx'

export default class MeetingLivestreamView {
  rootStore = null

  @observable accessor isInitializing = false
  @observable accessor isInitialized = false
  @observable accessor post = null
  @observable accessor sessionData = null

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  init = async () => {
    if (this.isInitializing) return

    runInAction(() => {
      this.isInitializing = true
    })

    if (!this.isValid) {
      this.#redirect().then()

      return
    }

    this.#updateSeo()
    await this.jitsi.init(this.post, this.sessionData)

    runInAction(() => {
      this.sessionData = null
      this.isInitializing = false
      this.isInitialized = true
    })
  }

  reset = async () => {
    if (!this.isInitialized) return

    await this.wallet.finishPurchase(this.post)

    runInAction(() => {
      this.post = null
      this.sessionData = null
      this.isInitializing = false
      this.isInitialized = false
    })

    this.jitsi.reset().then()
    this.users.reset()
    this.seo.reset()
  }

  get jitsi() {
    return this.rootStore.jitsiStore
  }

  get router() {
    return this.rootStore.routerStore
  }

  get seo() {
    return this.rootStore.seoStore
  }

  get users() {
    return this.rootStore.repositories.usersRepository
  }

  get wallet() {
    return this.rootStore.walletStore
  }

  @computed
  get exists() {
    return Boolean(this.post)
  }

  @computed
  get isValid() {
    return (
      this.post?.id === this.router.params.id &&
      ((this.router.isMeetingPage && this.post.isMeeting) ||
        (this.router.isLivestreamPage && this.post.isLivestream)) &&
      this.post.hasStarted &&
      !this.post.hasEnded
    )
  }

  @computed
  get canTip() {
    return this.jitsi.isConnected && this.jitsi.usersArray.length > 0
  }

  @computed
  get usersThatCanBeTippedCombobox() {
    return this.jitsi.usersArray
      .sort((a, b) => a.nickname.localeCompare(b.nickname))
      .map(this.#userToComboboxItem)
  }

  @computed
  get defaultUserToTipCombobox() {
    if (!this.isInitialized || !this.exists) return null

    return this.post.user.isAuthUser
      ? this.usersThatCanBeTippedCombobox[0]
      : this.#userToComboboxItem(this.jitsi.hostUser)
  }

  @action
  expect = (post, sessionData) => {
    if (!post.isMeeting && !post.isLivestream) return

    this.post = post
    this.sessionData = sessionData
  }

  #updateSeo = () => {
    if (!this.exists) return

    this.seo.update({
      description: this.post.description,
      image: this.post.imagePreview ?? this.post.user.cover,
      title: this.post.title,
    })
  }

  #redirect = async () => {
    const id = this.router.params.id
    const to = id ? this.router.routes.post : this.router.routes.index
    const params = id ? { id: this.router.params.id } : {}

    return this.router.navigate(to, {
      ignoreBlocker: true,
      params,
      replace: true,
    })
  }

  #userToComboboxItem = x =>
    x
      ? {
          label: x.nickname,
          value: x.nickname,
        }
      : null
}
